import ls from "../services/localStorage";
import { types } from "../constants/constants";

export const getApiFaqs = (attributes: any): Promise<object> => {
  const esc = encodeURIComponent;
  const query = Object.keys(attributes).length ? '?' + Object.keys(attributes).map(k => `${esc(k)}=${esc(attributes[k])}`).join('&') : '';
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}faqs${query}`, {
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const getApiFaq = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}faqs/id/${attributes._id}`, {
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const postApiCreateFaq = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}faq/create`, {
    method: "POST",
    headers: {
      token: token !== null ? token : '',
      "Content-Type": "application/json"
    },
    body: JSON.stringify(attributes)
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const putApiUpdateFaq = (attributes: any): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}faqs/update/id/${attributes.faq._id}`, {
    method: "PUT",
    headers: {
      token: token !== null ? token : '',
      "Content-Type": "application/json"
    },
    body: JSON.stringify(attributes)
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};

export const deleteApiFaq = (id: string): Promise<object> => {
  const token: string | null = ls.get("token");

  return fetch(`${types.API_URL}faqs/delete/id/${id}`, {
    method: "DELETE",
    headers: { token: token !== null ? token : '' }
  }).then(async (response) => {
    if (!response.ok) throw new Error(await response.json());
    return response.json();
  });
};
